import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Text from '../../../../Text'
import { TrackingItemDate } from '../TrackingItemDate'
import { TrackingStatusIcon } from '../TrackingStatusIcon'

import * as styles from './TrackingItem.module.css'

function TrackingItem({
  completed,
  current,
  date,
  isError,
  isLast,
  isLastCompletedBeforeError,
  titleKey,
}) {
  const { t } = useTranslation()

  return (
    <div className={styles.TrackingItem}>
      <TrackingStatusIcon
        completed={completed}
        current={current}
        isError={isError}
        isLast={isLast}
        isLastCompletedBeforeError={isLastCompletedBeforeError}
      />

      <div
        className={classNames(styles.content, {
          [styles.contentLast]: isLast,
        })}
      >
        <Text
          className={classNames({ [styles.textError]: isError })}
          isSecondary={!completed && !current}
        >
          {t(titleKey)}
        </Text>

        <TrackingItemDate current={current} date={date} />
      </div>
    </div>
  )
}

export default TrackingItem
